export default {
    imageAIFormRules: {
        enterDescription: 'Please enter the description',
        invalidDescription: 'Please enter the valid description',
        enterNumberOfVariations: 'Please select the number of variation',
        invalidNumberOfVariations: 'You can generate maximum 4 and minimum 1 variation',
        enterStyle: 'Please select at least one style',
    },
};
